import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { KeywordSearchState } from '../../types/KeywordSearch/state';
import { sessionSlice } from '../session';

const keywordSearchSlice = createSlice({
  name: 'keywordSearch',
  initialState: {
    isKeywordSearchModeOn: false,
    previousConversationId: '',
    selectedMessageId: '',
    selectedHighlightedMessageId: '',
    isGoToMessageNavigation: false,
    gotoMessageNavigationEvent: false,
    selectedConversationId: '', // ID FROM DB
    isFetching: false,
    keywordSearchTerm: '',
    loadConversationFinishTime: null,
    loadConversationStartTime: null,
    loadMessageStartTime: null,
  } as KeywordSearchState,
  reducers: {
    setKeywordSearchMode: (state, action: PayloadAction<boolean>) => {
      state.isKeywordSearchModeOn = action.payload;
    },
    setPreviousConversationId: (state, action: PayloadAction<string>) => {
      state.previousConversationId = action.payload;
    },
    setSelectedHighlightedMessageId: (state, action: PayloadAction<string>) => {
      state.selectedHighlightedMessageId = action.payload;
    },
    setSelectedMessageId: (state, action: PayloadAction<string>) => {
      state.selectedMessageId = action.payload;
    },
    setIsGoToMessageNavigation: (state, action: PayloadAction<boolean>) => {
      state.isGoToMessageNavigation = action.payload;
    },
    setGotoMessageNavigationEvent: (state, action: PayloadAction<boolean>) => {
      state.gotoMessageNavigationEvent = action.payload;
    },
    setSelectedConversationId: (state, action: PayloadAction<string>) => {
      state.selectedConversationId = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    setKeywordSearchTerm: (state, action: PayloadAction<string>) => {
      state.keywordSearchTerm = action.payload;
    },
    setLoadConversationStartTime: (state, action: PayloadAction<number | null>) => {
      state.loadConversationStartTime = action.payload;
    },
    setLoadConversationFinishTime: (state, action: PayloadAction<number | null | string>) => {
      state.loadConversationFinishTime = action.payload;
    },
    setLoadMessageStartTime: (state, action: PayloadAction<number | null>) => {
      state.loadMessageStartTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sessionSlice.actions.setCurrentOrganizationId, (state, action) => {
      if (action.payload) {
        state.isKeywordSearchModeOn = false;
        state.gotoMessageNavigationEvent = false;
      }
    });
  },
});

export { keywordSearchSlice };
